export default async () => {
  const commonStore = useCommonStore();

  const { data, ...result } = await useAsyncData(() => commonStore.fetchCommon(), { dedupe: 'defer' });

  assertNotEmpty(data, () => createError({ statusCode: 500, statusMessage: 'failed to load common data' }));

  data.value.sections.forEach((section) => {
    const parent = section.parentId ? data.value.sections.find((item) => item.id === section.parentId) : null;
    if (section.parentId && !parent) throw createError({ statusCode: 500, statusMessage: 'wrong sections hierarchy' });

    section.parent = parent;
  });

  return { ...result, data };
};
